import React from 'react';

import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';

type InputProps = {
  value: string;
  label: string;
  subtext?: string;
};

export const LabeledRadioButton = ({ value, label, subtext }: InputProps) => (
  <FormControlLabel
    value={value}
    control={<Radio />}
    label={
      <div className="u-margin-y-sm">
        <div>{label}</div>
        <div className="typo-subtitle">{subtext}</div>
      </div>
    }
  />
);
